import { render } from "./SizeTable.vue?vue&type=template&id=35a16626&scoped=true"
import script from "./SizeTable.vue?vue&type=script&lang=js"
export * from "./SizeTable.vue?vue&type=script&lang=js"

import "./SizeTable.vue?vue&type=style&index=0&id=35a16626&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a16626"]])

export default __exports__